/**
 * Types matrice d'éligibilité — alias FE typés sur le codegen OpenAPI.
 *
 * `frontend/src/types/api-generated.ts` est régénéré depuis les schémas Pydantic
 * du backend par `npm run gen:api` (non commité).
 * Cf. `backend/app/schemas/eligibility.py` pour la source Pydantic.
 *
 * Lookups FR : labels d'affichage UI + groupes pour la matrice
 * `<PlatformRulesTab>` (3 catégories de dimensions).
 */

import type { components } from './api-generated'

// ── Schémas générés (Pydantic → OpenAPI → TS) ────────────────────────────

export type EligibilityRuleResponse = components['schemas']['EligibilityRuleResponse']
export type EligibilityRuleUpdate = components['schemas']['EligibilityRuleUpdate']

export type BlockingTagResponse = components['schemas']['BlockingTagResponse']
export type BlockingTagInsert = components['schemas']['BlockingTagInsert']
export type BlockingTagPatch = components['schemas']['BlockingTagPatch']

export type EligibilityBulkUpdateRequest = components['schemas']['EligibilityBulkUpdateRequest']
export type EligibilityBulkUpdateResponse = components['schemas']['EligibilityBulkUpdateResponse']

export type WorkEligibilityPreview = components['schemas']['WorkEligibilityPreview']
export type WorkEligibilityExclusion = components['schemas']['WorkEligibilityExclusion']

export type EligibilityDimension = components['schemas']['EligibilityDimension']
export type ExclusionCode = components['schemas']['ExclusionCode']

// ── Lookups FR ──────────────────────────────────────────────────────────

export const ELIGIBILITY_DIMENSION_FR: Record<EligibilityDimension, string> = {
  media_image: 'Photo statique',
  media_video: 'Vidéo',
  variant_digital: 'Variante digitale',
  variant_print: 'Variante print',
  edition_open: 'Édition ouverte',
  edition_limited: 'Édition limitée',
  edition_original: 'Original unique 1/1',
}

export const EXCLUSION_CODE_FR: Record<ExclusionCode, string> = {
  no_media_match: 'Type de média incompatible',
  no_variant_match: 'Aucune variante distribuable',
  no_edition_match: "Type d'édition non supporté",
  blocked_by_tag: 'Tag bloquant',
  variants_not_active: 'Variante en brouillon',
}

// ── Groupes pour rendu matrice 3 catégories (cf. plan §15) ──────────────

export type DimensionGroup = {
  readonly label: string
  readonly dimensions: readonly EligibilityDimension[]
}

export const DIMENSION_GROUPS: readonly DimensionGroup[] = [
  {
    label: 'Type de média',
    dimensions: ['media_image', 'media_video'] as const,
  },
  {
    label: 'Type de variante',
    dimensions: ['variant_digital', 'variant_print'] as const,
  },
  {
    label: 'Édition',
    dimensions: ['edition_open', 'edition_limited', 'edition_original'] as const,
  },
] as const
